import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=ac306b84&scoped=true&"
import script from "./Japanese.vue?vue&type=script&lang=js&"
export * from "./Japanese.vue?vue&type=script&lang=js&"
import style0 from "./Japanese.vue?vue&type=style&index=0&id=ac306b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac306b84",
  null
  
)

export default component.exports